import type { PublicMasterProfile } from '../../types/auth';

const normalizeMasterSearch = (value: string): string => value.trim().toLocaleLowerCase();

/** Keep searchable master dropdowns responsive while the server query is in flight. */
export const filterMasterOptions = (
  options: readonly PublicMasterProfile[],
  query: string,
): PublicMasterProfile[] => {
  const normalizedQuery = normalizeMasterSearch(query);
  if (!normalizedQuery) return options.slice();

  return options.filter((master) => (
    normalizeMasterSearch(master.name ?? '').includes(normalizedQuery)
  ));
};
